<template>
  <div class="Management-Guide-main" :class="{ 'Management-Guide-main-mobile': isMobile}">
    <Base-title title="产品隐私管理指南"></Base-title>
    <Product-privacy></Product-privacy>
    <Management-guide-content></Management-guide-content>
  </div>
</template>
<script>
  import ProductPrivacy from './ProductPrivacy.vue';
  export default {
    // 隐私管理指南
    name: 'ManagementGuide',
    components: { ProductPrivacy }
  };
</script>
<style lang="scss" scoped>
  .Management-Guide-main {
    position: relative;
    display: flex;
    align-items: center;
    overflow: hidden;
    width: calc($multiple * 1040px);
    margin: auto;
    padding-top: calc($multiple * 78px);
    background: #fff;
    flex-direction: column;
  }
  .Management-Guide-main-mobile {
    padding-top: 2.1rem;
    /* height: 29.8rem; */
    width: auto;
  }
</style>
